import React from 'react';
import IDividedContent from './IDividedContent';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './DividedContentStyle.module.scss'
import * as appStyle from './../../FundsAppStyle.module.scss';

const DividedContent: React.FunctionComponent<IDividedContent> = (props: IDividedContent) => {
  return (
    <main
      className={classNames(
        style.dividedContent,
        style.dividedContentNoVerticalSpacing
      )}
    >
      <div className={appStyle.left}>
        {props.leftComponent}
      </div>
      <aside className={appStyle.right}>
        {props.rightComponent}
      </aside>
    </main>
  );
};

export default DividedContent;
